import { BffApiCreateItemError } from '../../../../types';

import {
  PayoneerCheckoutAttemptInvoiceID,
  PayoneerCheckoutAttemptPaymentDataLinksSelf,
  PayoneerCheckoutAttemptPaymentDataLongId,
  CreatePayoneerCheckoutAttemptCacheKeys
} from '../../payoneerCheckoutAttemptsTypes';

import { useBffCreateQuery } from '../../../common/reactQuery/hooks/useBffCreateQuery';

import { PayoneerCheckoutAttemptBffUrl } from '../../PayoneerCheckoutAttemptBffUrl';

interface CreatePayoneerCheckoutAttemptOptions {
  cacheKeys?: CreatePayoneerCheckoutAttemptCacheKeys;
}

export interface CreatePayoneerCheckoutAttemptInput {
  payoneerCheckoutAttempt: {
    invoiceId: PayoneerCheckoutAttemptInvoiceID;
    integration?: 'embedded' | 'selective_native';
  };
}

export type CreatePayoneerCheckoutAttemptError = BffApiCreateItemError;

interface CreatePayoneerCheckoutAttemptResponseType {
  paymentData: {
    identification?: {
      long_id: PayoneerCheckoutAttemptPaymentDataLongId;
    };
    links?: {
      self: PayoneerCheckoutAttemptPaymentDataLinksSelf;
    };
  };
}

function useCreatePayoneerCheckoutAttempt({
  cacheKeys
}: CreatePayoneerCheckoutAttemptOptions = {}) {
  const { createQuery, createQueryErrorMessage, createQueryLoading } =
    useBffCreateQuery<
      CreatePayoneerCheckoutAttemptInput,
      CreatePayoneerCheckoutAttemptResponseType,
      CreatePayoneerCheckoutAttemptError,
      CreatePayoneerCheckoutAttemptResponseType
    >({ url: PayoneerCheckoutAttemptBffUrl.create(), cacheKeys });

  return {
    createPayoneerCheckoutAttemptLoading: createQueryLoading,
    createPayoneerCheckoutAttemptErrorMessage: createQueryErrorMessage,
    createPayoneerCheckoutAttempt: createQuery
  };
}

export default useCreatePayoneerCheckoutAttempt;
